import { viewActions } from 'store/view'

const STUDY_MODULE_VIEWPORT_SEGMENTS = ['instruments', 'visit-schedules', 'consents']

/**
 * Path segments after /studies/:studyID/:studyVersionID/
 */
export function getStudySubPath(pathname) {
  const parts = pathname.split('/').filter(Boolean)
  const studiesIdx = parts.indexOf('studies')
  if (studiesIdx === -1) return []
  return parts.slice(studiesIdx + 3)
}

/**
 * True when the URL continues past a study module segment (e.g. /instruments/:id/edit).
 */
export function isStudyModuleChildPath(pathname, moduleSegment) {
  const subPath = getStudySubPath(pathname)
  const moduleIdx = subPath.indexOf(moduleSegment)
  return moduleIdx !== -1 && subPath.length > moduleIdx + 1
}

/**
 * True when the URL ends at a study module segment (e.g. /instruments, /visit-schedules).
 */
export function isModuleIndexPath(pathname, moduleSegment) {
  if (!moduleSegment) return true
  const subPath = getStudySubPath(pathname)
  const moduleIdx = subPath.indexOf(moduleSegment)
  return moduleIdx !== -1 && subPath.length === moduleIdx + 1
}

/**
 * Full-width layout is only for module child routes (editors, builders).
 * Index/list pages keep the sidebar visible.
 */
export function syncStudyModuleViewport(store, location, moduleSegment) {
  syncViewportForPathname(location.pathname, action => store.dispatch(action))
}

/**
 * Keeps sidebar/navbar hidden for study module editors on every navigation.
 * React Router v6 no longer re-runs cached getChildRoutes callbacks when only the URL changes.
 */
export function syncViewportForPathname(pathname, dispatch) {
  const subPath = getStudySubPath(pathname)
  const eConsentIdx = subPath.indexOf('e-consent')

  if (eConsentIdx !== -1) {
    if (subPath.length > eConsentIdx + 1) {
      dispatch(viewActions.setFullWidth())
    } else {
      dispatch(viewActions.setNormalWidth())
    }
    return
  }

  for (const segment of STUDY_MODULE_VIEWPORT_SEGMENTS) {
    if (subPath.includes(segment)) {
      if (isStudyModuleChildPath(pathname, segment)) {
        dispatch(viewActions.setFullWidth())
      } else {
        dispatch(viewActions.setNormalWidth())
      }
      return
    }
  }

  dispatch(viewActions.setNormalWidth())
}
